var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSecurityGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2236 48.3121L24.4396 43.5601L49.0796 57.7921L40.8716 62.5361L16.2236 48.3121Z",
    fill: "url(#paint0_linear_1352_200748)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9282 26.3201C48.8312 26.1526 48.6936 26.0123 48.5281 25.912L47.6481 25.4L24.8641 12.248C24.807 12.2068 24.7403 12.1808 24.6703 12.1724C24.6004 12.164 24.5294 12.1735 24.4641 12.2L16.3761 16.864C16.2881 16.92 18.1041 39.88 18.1041 39.88L21.5441 42.112L49.0081 26.48C48.9864 26.4244 48.9596 26.3709 48.9282 26.3201Z",
    fill: "url(#paint1_linear_1352_200748)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.928 49.96C48.9917 49.9198 49.0428 49.8625 49.0753 49.7945C49.1079 49.7266 49.1206 49.6508 49.112 49.576V26.912C49.107 26.7624 49.0716 26.6155 49.008 26.48L21.544 42.112L40.84 54.624L48.928 49.96Z",
    fill: "url(#paint2_linear_1352_200748)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.928 49.96C48.9917 49.9198 49.0428 49.8625 49.0753 49.7945C49.1079 49.7266 49.1206 49.6508 49.112 49.576V26.912C49.107 26.7624 49.0716 26.6155 49.008 26.48L21.544 42.112L40.84 54.624L48.928 49.96Z",
    fill: "url(#paint3_linear_1352_200748)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5037 25.1201C37.5159 25.2392 37.5593 25.3529 37.6295 25.4498C37.6998 25.5468 37.7943 25.6234 37.9037 25.6721C38.2029 25.822 38.533 25.9001 38.8677 25.9001C39.2024 25.9001 39.5325 25.822 39.8317 25.6721C39.9406 25.6217 40.0343 25.5433 40.1032 25.4449C40.172 25.3466 40.2136 25.2317 40.2237 25.1121V14.6161C40.2237 10.3041 36.9037 5.0161 32.6557 2.5601C30.2557 1.1521 27.8557 0.960096 26.0797 1.9361C24.5597 2.8081 23.6797 4.4881 23.6797 6.6481V17.2001C23.6905 17.3206 23.7333 17.436 23.8036 17.5344C23.8739 17.6329 23.9692 17.7108 24.0797 17.7601C24.3775 17.9099 24.7063 17.988 25.0397 17.988C25.3731 17.988 25.7019 17.9099 25.9997 17.7601C26.1092 17.7094 26.2036 17.6312 26.2737 17.533C26.3439 17.4348 26.3873 17.3201 26.3997 17.2001V6.6481C26.356 6.19854 26.4287 5.74531 26.6108 5.33199C26.793 4.91867 27.0784 4.55918 27.4397 4.2881C28.3037 3.7921 29.7437 4.0241 31.2957 4.9201C34.6637 6.8641 37.5037 11.3201 37.5037 14.6161V25.1201Z",
    fill: "url(#paint4_linear_1352_200748)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.448 30.576L39.568 30.072L16.8 16.912C16.7445 16.8637 16.6752 16.834 16.6019 16.827C16.5287 16.8201 16.4551 16.8364 16.3915 16.8734C16.3279 16.9105 16.2776 16.9666 16.2475 17.0338C16.2175 17.101 16.2092 17.1759 16.224 17.248V39.912C16.232 40.1221 16.2955 40.3264 16.408 40.504C16.5022 40.6709 16.637 40.8112 16.8 40.912L39.568 54.072L40.448 54.576C40.5036 54.6172 40.5689 54.6433 40.6377 54.6518C40.7064 54.6602 40.7761 54.6506 40.84 54.624C40.9031 54.5851 40.9538 54.5292 40.9864 54.4626C41.019 54.3961 41.032 54.3217 41.024 54.248V31.576C41.0124 31.376 40.9543 31.1815 40.8543 31.0079C40.7543 30.8343 40.6152 30.6864 40.448 30.576Z",
    fill: "url(#paint5_linear_1352_200748)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 33.3041C30.3648 32.6795 30.1837 32.0719 29.8711 31.53C29.5584 30.9882 29.1231 30.5272 28.6 30.1841C27.6 29.6081 26.792 30.0801 26.792 31.2241C26.8218 31.941 27.0549 32.6346 27.464 33.2241L26.792 37.4721L30.4 39.5521L29.728 34.5361C29.9567 34.4292 30.1453 34.252 30.2662 34.0304C30.3871 33.8088 30.434 33.5543 30.4 33.3041Z",
    fill: "url(#paint6_linear_1352_200748)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.128 30.808C41.0021 30.5957 40.8263 30.4172 40.616 30.288L39.736 29.784L16.944 16.624L16.864 16.584L16.376 16.864C16.4205 16.8521 16.4674 16.8521 16.512 16.864C16.6032 16.8658 16.692 16.8936 16.768 16.944L39.568 30.072L40.448 30.576C40.6093 30.6788 40.7437 30.8187 40.84 30.984C40.84 30.984 40.88 31.056 40.904 31.096L41.192 30.928L41.128 30.808Z",
    fill: "url(#paint7_linear_1352_200748)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_200748",
    x1: 22.3836,
    y1: 58.9761,
    x2: 42.9196,
    y2: 47.1201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1352_200748",
    x1: 13.8641,
    y1: 32.544,
    x2: 42.8561,
    y2: 15.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1352_200748",
    x1: 22.872,
    y1: 12.808,
    x2: 47.104,
    y2: 54.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8D8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1352_200748",
    x1: 21.544,
    y1: 40.552,
    x2: 49.112,
    y2: 40.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1352_200748",
    x1: 684.943,
    y1: 796.976,
    x2: 684.943,
    y2: 41.6263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1352_200748",
    x1: 19.664,
    y1: 35.744,
    x2: 41.296,
    y2: 35.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1352_200748",
    x1: 26.176,
    y1: 36.3681,
    x2: 31.056,
    y2: 33.5521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8D8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1352_200748",
    x1: 16.488,
    y1: 16.68,
    x2: 42.16,
    y2: 31.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FDFDFD",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBFBFB",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F7F7F7",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3F3F3",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EDEDED",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E6E6E6",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#DFDFDF",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D6D6D6",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSecurityGroup);
export default __webpack_public_path__ + "static/media/no_security_group.cfa40514288de7bbe98e260ab15c4544.svg";
export { ForwardRef as ReactComponent };